import { ReactNode } from "react";
import styles from './index.module.scss';

type ButtonProps = {
  children: ReactNode;
  color?: "black" | "white";
  isFullWidth?: boolean;
  onClick?: () => void;
};

export const Button = (props: ButtonProps) => {
    return (
    <button 
        onClick={props.onClick}
        className={`
        ${styles.button}
        ${props.color === "white" ? styles.white : styles.black}
        ${props.isFullWidth ? styles.fullWidth : ""}
    `
    }>
        {props.children}
    </button>
    );
};